import { useEffect } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";
import { toast } from "sonner";

export default function BillingSuccessPage() {
  const [params] = useSearchParams();
  const subId = params.get("sub");

  useEffect(() => {
    toast.success("Subscription confirmed");
  }, []);

  return (
    <div className="max-w-md mx-auto px-4 sm:px-6 py-16 text-center" data-testid="billing-success">
      <div className="grid place-items-center mb-4">
        <div className="w-14 h-14 grid place-items-center bg-emerald-50 border border-emerald-200">
          <CheckCircle2 size={28} className="text-emerald-700" />
        </div>
      </div>
      <div className="text-xs font-mono-tech tracking-[0.25em] text-[#FF5100] mb-2">SUBSCRIPTION · ACTIVE</div>
      <h1 className="font-display text-3xl sm:text-4xl font-extrabold leading-none mb-3">You're all set.</h1>
      <p className="text-sm text-neutral-600 mb-6">
        Your card is securely tokenised by PayFast. You won't be charged for the next 30 days — your first
        billing date is at the end of your free trial. Cancel anytime from your dashboard.
      </p>
      {subId && <div className="text-[10px] font-mono-tech text-neutral-400 mb-6">REF · {subId}</div>}
      <Link
        to="/"
        data-testid="billing-success-home"
        className="inline-flex items-center gap-2 px-5 h-11 bg-[#FF5100] hover:bg-[#E64A00] text-white text-xs font-bold uppercase tracking-wider"
      >
        Back to dashboard
      </Link>
    </div>
  );
}
